export const ArrowUp = require('./arrowUp.png');
export const ArrowDown = require('./arrowDown.png');